import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../../../constants/colors.js';
var listItemsThemeWeb = {
  color: 'primary',
  background: 'background',
  textColor: 'text',
  active: colors.lightGrey,
  autocompleteText: colors.fogGrey,

  /**
   * Directly passed to white-space css rule for each item in the list
   */
  whiteSpace: 'nowrap',
  borders: {
    width: 2
  },
  boxShadow: 'none'
};

var listItemsDarkThemeWeb = _extends({}, listItemsThemeWeb, {
  active: colors.mineShaftGrey,
  autocompleteText: colors.octoberGrey
});

export { listItemsDarkThemeWeb, listItemsThemeWeb };